import { render, staticRenderFns } from "./MessageRecharge.vue?vue&type=template&id=cd80dd4e&scoped=true&"
import script from "./MessageRecharge.vue?vue&type=script&lang=js&"
export * from "./MessageRecharge.vue?vue&type=script&lang=js&"
import style0 from "./MessageRecharge.vue?vue&type=style&index=0&id=cd80dd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd80dd4e",
  null
  
)

export default component.exports